export const getFoldersQueryName = (isModalVersion: boolean) =>
  `folders-${isModalVersion ? 'modal' : 'page'}`;
